import React, { useRef } from "react";
import { Box } from "@mui/system";
import Actions from "./Actions";
import style from "./style.module.scss";
import { Typography } from "@mui/material";
import useDragField from "../../../../customHook/useDragField";

function ParagraphField({
  id,
  main_id,
  type,
  value,
  field_style,
  two_col,
  col_name,
  index,
  moveCard,
}) {
  const ref = useRef(null);
  const dragField = useDragField(ref, index, moveCard, id);
  const opacity = dragField.opacity;

  return (
    <Box
      ref={ref}
      style={{ ...style, opacity }}
      data-handler-id={dragField?.handlerId}
      className={`${style.inputBox} dropItem`}
    >
      <Actions
        type={type}
        id={id}
        two_col={two_col}
        col_name={col_name}
        main_id={main_id}
      />
      <Typography
        id={id}
        style={{
          fontSize: `${field_style.font_size}px`,
          color: `${field_style.text_color}`,
        }}
        variant="p"
        component="p"
      >
        {value}
      </Typography>
    </Box>
  );
}

export default ParagraphField;
